import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

export function Logo({ className = "", dark = false, size = "text-2xl" }) {
  const { settings } = useSettings();
  const logo = settings?.logo;
  if (logo) {
    const h = size.includes("3xl") ? "h-16" : size.includes("2xl") ? "h-11" : size.includes("lg") ? "h-8" : size.includes("sm") ? "h-7" : "h-10";
    const txt = size.includes("3xl") ? "text-2xl" : size.includes("lg") ? "text-lg" : size.includes("sm") ? "text-sm" : "text-xl";
    return (
      <Link to="/" data-testid="metros-logo" className={`inline-flex items-center gap-2.5 ${className}`}>
        <img src={logo} alt="METROS" data-testid="metros-logo-img" className={`${h} w-auto object-contain`} />
        <span className={`font-heading font-extrabold tracking-tight ${txt}`}>
          <span className={dark ? "text-white" : "text-metros-black"}>MET</span><span className="text-metros-red">ROS</span>
        </span>
      </Link>
    );
  }
  return (
    <Link to="/" data-testid="metros-logo" className={`font-heading font-extrabold tracking-tight ${size} ${className}`}>
      <span className={dark ? "text-white" : "text-metros-black"}>MET</span>
      <span className="text-metros-red">ROS</span>
    </Link>
  );
}

export function Stars({ rating = 5, size = 16 }) {
  return (
    <div className="flex items-center gap-0.5" aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <svg key={i} width={size} height={size} viewBox="0 0 24 24"
          fill={i <= rating ? "#E51937" : "none"} stroke={i <= rating ? "#E51937" : "#D4D4D8"} strokeWidth="1.5">
          <path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z" />
        </svg>
      ))}
    </div>
  );
}
